import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import axios from 'axios';
import { ArrowLeft } from 'lucide-react';

const NewMonitor = () => {
  const [companyUrl, setCompanyUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();
  const { t } = useTranslation();
  const API_URL = process.env.REACT_APP_BACKEND_URL;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const { data } = await axios.post(
        `${API_URL}/api/monitors`,
        { company_url: companyUrl, country: '' },
        { withCredentials: true }
      );

      navigate(`/monitor/${data.id}`);
    } catch (err) {
      setError(err.response?.data?.detail || t('new_monitor.ошибка_создания'));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#FFFFFF]">
      <header className="bg-white/80 backdrop-blur-xl border-b border-[#E2DDD8]">
        <div className="w-full max-w-[1400px] mx-auto px-6 md:px-12 py-6 flex items-center gap-4">
          <button
            onClick={() => navigate('/dashboard')}
            className="flex items-center gap-2 text-[#1BB594] hover:underline font-semibold"
            data-testid="back-button"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
          <div className="flex items-baseline gap-1.5">
            <img src="/arpai_logo.png" alt="ARPAI" style={{height: '1.25rem'}} />
            <span className="text-xl font-bold text-[#2F2E2F] tracking-[0.15em]">GEO</span>
            <span className="hidden sm:inline text-[10px] text-slate-400 ml-2">{t('new_monitor.сервис_слоган')}</span>
          </div>
        </div>
      </header>

      <main className="w-full max-w-[900px] mx-auto px-6 md:px-12 py-16 md:py-24">
        <h1 className="text-4xl sm:text-5xl lg:text-6xl tracking-tighter leading-none font-black text-[#2F2E2F] mb-8">
          {t('new_monitor.новый_проект')}
        </h1>

        {error && (
          <div className="mb-8 p-4 bg-red-50 border border-red-200 text-red-700" data-testid="error-message">
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="space-y-12" data-testid="new-monitor-form">
          <div>
            <label className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500 block mb-4">
              {t('new_monitor.url_сайта')}
            </label>
            <input
              type="url"
              value={companyUrl}
              onChange={(e) => setCompanyUrl(e.target.value)}
              placeholder="https://example.com"
              className="w-full rounded-none border-b-2 border-l-0 border-r-0 border-t-0 border-[#E2DDD8] bg-transparent focus:ring-0 focus:border-[#1BB594] px-0 py-4 text-3xl sm:text-4xl lg:text-5xl font-bold"
              required
              data-testid="company-url-input"
            />
            <p className="text-xs text-slate-400 mt-2">
              {t('new_monitor.не_вводите_пдн')}
            </p>
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full rounded-none font-bold tracking-widest uppercase text-xs px-8 py-6 bg-[#1BB594] hover:bg-[#159A7F] text-white transition-transform active:translate-y-1 disabled:opacity-50"
            data-testid="submit-button"
          >
            {loading ? t('new_monitor.создание') : t('new_monitor.создать_проект')}
          </button>
        </form>

        <div className="mt-12 p-6 bg-blue-50 border border-blue-200">
          <p className="text-sm text-blue-900">
            <strong>{t('new_monitor.как_работает_заголовок')}</strong> {t('new_monitor.как_работает_описание')}
          </p>
        </div>
      </main>
    </div>
  );
};

export default NewMonitor;
